import { CreateControllerFn } from '@wix/yoshi-flow-editor';
import { createState } from './state/createState';
import { initialStateFactory } from './state/initialStateFactory';
import {
  createDailyAgendaActions,
  DailyAgendaActions,
} from './actions/actions';
import {
  createDailyAgendaViewModel,
  WidgetViewModel,
} from './viewModel/viewModel';
import { initViewModelSubscriptions } from './viewModel/initViewModelSubscriptions';
import { initWidgetData } from '../../adapters/initWidgetData/initWidgetData';
import { ISettingsParams } from './settingsParams';
import { DailyAgendaBiLogger } from '../../utils/bi/biLogger';
import { withErrorHandler } from '@wix/bookings-viewer-error-handler';

export type ControllerProps = {
  viewModel: WidgetViewModel;
  actions?: DailyAgendaActions;
};

const createController: CreateControllerFn = async ({
  flowAPI,
  controllerConfig,
}) => {
  if (flowAPI.experiments.enabled('specs.bookings.withErrorHandler')) {
    withErrorHandler({
      httpClient: flowAPI.httpClient,
      errorHandler: flowAPI.errorHandler,
    });
  }
  const setProps: (props: ControllerProps) => void = controllerConfig.setProps;

  const initialState = initialStateFactory({ flowAPI });
  const { getState, setState, subscribe } = createState(initialState);
  const biLogger = new DailyAgendaBiLogger(flowAPI, getState);
  const actions = createDailyAgendaActions({
    getState,
    setState,
    flowAPI,
    biLogger,
  });

  const initialViewModel = createDailyAgendaViewModel({
    state: getState(),
    flowAPI,
  });

  setProps({ viewModel: initialViewModel, actions });

  biLogger.subscribeToStateChanges(subscribe);
  initViewModelSubscriptions({
    getState,
    flowAPI,
    subscribe,
    setProps,
    viewModel: initialViewModel,
    biLogger,
  });

  const pageReady = async () => {
    setState(initialState);

    initWidgetData({
      flowAPI,
      setState,
      getState,
      biLogger,
    });
  };

  return {
    pageReady,
    updateConfig: ($w, updatedConfig) => {
      const updatedPublicData: {
        [key in keyof ISettingsParams]: any;
      } = updatedConfig.publicData.COMPONENT || {};

      setState({ settings: updatedPublicData });
    },
  };
};

export default createController;
